import type { Educando } from 'shared';
import { presenceText } from '@/lib/educando';

/** Whether an educando is checked in at a centre right now. */
export default function PresenceBadge({ educando }: { educando: Pick<Educando, 'presence'> }) {
  const here = presenceText(educando);
  if (here) {
    return (
      <p className="inline-flex items-center gap-2 rounded-full bg-available-soft px-3 py-1 text-xs font-bold text-available">
        <span className="h-2 w-2 rounded-full bg-available" aria-hidden="true" />
        No Centro agora · {here}
      </p>
    );
  }
  return (
    <p className="inline-flex items-center gap-2 rounded-full bg-input-soft px-3 py-1 text-xs font-semibold text-muted-foreground">
      <span className="h-2 w-2 rounded-full bg-border-strong" aria-hidden="true" />
      Não está num Centro
    </p>
  );
}
